import { createSelector } from '@ngrx/store';
import { getMXMState } from '@store/reducers';
import { MXMState } from '@store/reducers/mxm/mxm.reducer';
import { selectSelectedAccountFromIsManaged } from '@store/selectors/client-accounts/client-accounts.selectors';
import { selectSelectedPositions } from '@store/selectors/cost-basis/cost-basis.selectors';

import { nullState } from '../common/router.selectors';
import {
  getGiftingAdditionalInstructionsNextPage,
  getGiftingAssetsNextPage,
  getGiftingMethodNextPage,
  getGiftingOverviewNextPage,
  getGiftingRecipientNextPage,
  getGiftingRecipientTriageNextPage,
  getGiftingReviewNextPage,
  getGiftingTermsNextPage,
  getGiftingTriageNextPage,
} from './gifting-router.helpers';

export const selectGiftingOverviewNextPage = createSelector(nullState, () =>
  getGiftingOverviewNextPage(),
);
export const selectGiftingTriageNextPage = createSelector(nullState, () =>
  getGiftingTriageNextPage(),
);
export const selectGiftingAssetsNextPage = createSelector(nullState, () =>
  getGiftingAssetsNextPage(),
);
export const selectGiftingRecipientNextPage = createSelector(nullState, () =>
  getGiftingRecipientNextPage(),
);

export const selectGiftingReviewNextPage = createSelector(getMXMState, (mxmState: MXMState) =>
  getGiftingReviewNextPage(mxmState),
);

export const selectGiftingTermsNextPage = createSelector(getMXMState, (mxmState: MXMState) =>
  getGiftingTermsNextPage(mxmState),
);
export const selectGiftingRecipientTriageNextPage = createSelector(nullState, () =>
  getGiftingRecipientTriageNextPage(),
);
export const selectGiftingMethodNextPage = createSelector(
  selectSelectedPositions,
  selectSelectedAccountFromIsManaged,
  (selectedPositions, isAdvisedClient) =>
    getGiftingMethodNextPage(selectedPositions, isAdvisedClient),
);
export const selectGiftingAdditionalInstructionsNextPage = createSelector(nullState, () =>
  getGiftingAdditionalInstructionsNextPage(),
);
